import './accountMenu.scss';
import React from 'react';
import { useCallback } from 'react';
import { doLogOut } from '../../../../services/authorizationService';
import { PlainText } from '../../../plainText/plainText';

export interface IProps {

}

export function AccountMenu(props: IProps) {
    const logout = useCallback(() => {
        doLogOut();
    }, []);

    return (
        <div className="current-account-actions">
        <div className="action to-profile">
            <a href="/profile#/profile" className="btn">
                <PlainText>个人中心</PlainText>
            </a>
        </div>
        <div className="action to-logout">
            <a href="javascript:;" className="btn" onClick={logout}>
                <PlainText>退出账户</PlainText>
            </a>
        </div>
    </div>
    );
}
